
import { CaixaLotteryType } from "./types";
import { CAIXA_LOTTERIES } from "./lotteryData";

export const calculateCost = (lotteryType: CaixaLotteryType, gamesCount: number): number => {
  const lottery = CAIXA_LOTTERIES[lotteryType];
  return lottery.price * gamesCount;
};
